<template>
  <div id="app" class="content">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@font-face {
  font-family: 'Gobold';
  font-style: normal;
  font-weight: normal;
  src: url('./assets/fonts/Gobold Lowplus.otf') format('otf');
}
</style>